import { Button, Col, DatePicker, PageHeader, Row, Tag } from "antd";

import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

import {
  fetchMasterDropdown,
  setBlurModal,
} from "../../core/store/reducers/settings.slice";
import {
  fetchTicketsList,
  fetchTicketsListCount,
  getContactEmployeesByIds,
  getContactRoles,
} from "../../core/store/reducers/tickets.slice";
import {
  ACCOUNT_PREFIX,
  BASE_WEB_URL_CRM,
  RootState,
} from "../../shared/constants";
import TableLayout from "../../shared/layouts/table.layout";
import TabsLayout from "../../shared/layouts/tabs.layout";
import {
  formatDateTime,
  formatDropDownValue,
  formatDropDownValueNoUppercase,
  getDaysDiff,
  getSortDir,
} from "../../shared/utilities";
import CreateTicket from "./component/create-ticket.component";
const { RangePicker } = DatePicker;

function TicketsPage() {
  const dispatch = useDispatch();
  const { master_dropdown } = useSelector((state: RootState) => state.settings);
  const { myPermissions, incentive_portal_manager_view, incentive_portal_admin_view } = useSelector(
    (state: RootState) => state.auth
  );
  const { loading_tickets, tickets, pagination, contact_roles } = useSelector(
    (state: RootState) => state.tickets
  );
  const [ticketFormVisible, setTicketFormVisible] = useState(false as any);
  const [listData, setListData] = useState([] as any);
  const [countsData, setCountsData] = useState({ open: 0, closed: 0 } as any);
  const [employeeList, setEmployeeList] = useState([] as any);

  // Actions and selections
  const [selectedStatus, setSelectedStatus] = useState("" as any);
  const [statusList, setStatusList] = useState([] as any);
  const [filters, setFilters] = useState({ type: "self" } as any);
  const [sorters, setSorters] = useState({
    sort_column: "created_at",
    sort_val: null,
  } as any);

  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };

  useEffect(() => {
    master_dropdown?.length === 0 && dispatch(fetchMasterDropdown());
  }, []);
  useEffect(() => {
    if (master_dropdown?.length > 0) {
      const statuses = master_dropdown?.filter(
        (val: any) => val.name == "status"
      );
      if (statuses?.length > 0 && statuses[0]?.values) {
        setStatusList(
          statuses[0].values?.filter(
            (val: any) => ["open", "closed"].indexOf(val.name) !== -1
          )
        );
        if (statuses[0]?.values[0]?.id)
          setSelectedStatus(statuses[0].values[0].id);
      }
    }
  }, [master_dropdown]);
  // const getURL = (id: string) =>
  //   BASE_WEB_URL_CRM +
  //   CLIENT_NAME +
  //   "?redirect_uri=" +
  //   BASE_WEB_URL_CRM +
  //   "crm/ticket/" +
  //   id;
  const getURL = (id: string) =>
    BASE_WEB_URL_CRM +
    ACCOUNT_PREFIX +
    "/crm/login" +
    "?redirect_url=" +
    BASE_WEB_URL_CRM +
    "crm/ticket/" +
    id;
  const columns = [
    {
      title: "Employee Details",
      key: "employee",
      className: "capitalize",
      render: (record: any) => {
        return (
          <>
            <a href={getURL(record?.id)} target="_blank" rel="noreferrer">
              {record?.contact?.first_name + " " + record?.contact?.last_name}
            </a>
            <br />
            Ticket No: {record?.display_id}
            <br />
            Employee ID: {record?.contact?.uhid}
          </>
        );
      },
    },
    {
      title: "Module",
      key: "module",
      className: "capitalize",
      render: (record: any) => {
        return <>{formatDropDownValueNoUppercase(record?.type?.name)}</>;
      },
    },
    {
      title: "Ticket Category",
      key: "category",
      className: "capitalize",
      render: (record: any) => {
        return <>{formatDropDownValueNoUppercase(record?.sub_type?.name)}</>;
      },
    },
    {
      title: "Ticket Sub-Category",
      key: "sub-category",
      className: "capitalize",
      render: (record: any) => {
        return <>{formatDropDownValueNoUppercase(record?.category?.name)}</>;
      },
    },
    {
      title: "Assignee",
      key: "assignee",
      className: "capitalize",
      render: (record: any) => {
        return (
          <>
            {record?.assigned_user ? (
              <>
                {record?.assigned_user?.first_name +
                  " " +
                  record?.assigned_user?.last_name}
                <br />
                (Customer Care)
              </>
            ) : (
              "-"
            )}
          </>
        );
      },
    },
    {
      title: "Status",
      key: "status",
      className: "capitalize",
      render: (record: any) => {
        return <>{formatDropDownValue(record?.status?.name)}</>;
      },
    },
    {
      title: "Created at",
      key: "created_at",
      className: "capitalize",
      sorter: true,
      ...(sorters?.sort_column === "created_at"
        ? {
            defaultSortOrder:
              sorters?.sort_val === "asc"
                ? "ascend"
                : sorters?.sort_val === "desc"
                ? "descend"
                : false,
          }
        : {}),
      onHeaderCell: (column: any) => {
        return {
          onClick: (e: any) => {
            setSorters({
              sort_column: "created_at",
              sort_val: getSortDir(sorters.sort_val),
            });
          },
        };
      },
      render: (record: any) => {
        return (
          <>
            {formatDateTime(record?.created_at)}
            {getDaysDiff(record.created_at) > 0 &&
              record?.status?.name !== "closed" && (
                <>
                  <br />
                  <Tag color="#EB872A">
                    Open since last {getDaysDiff(record.created_at)} days
                  </Tag>
                </>
              )}
          </>
        );
      },
    },
  ];

  useEffect(() => {
    selectedStatus &&
      (filters?.type == "self" || filters?.type == "*" || filters?.contact_ids) &&
      loadList();
  }, [filters, selectedStatus, sorters]);
  const loadList = (offset: number = 0) => {
    let filter = {};
    if (filters?.role && filters?.contact_ids) {
      filter = { contact_id: filters?.contact_ids };
    }
    if(filters?.type == '*'){
      filter = { contact_id: '*' };
    }
    // if(!incentive_portal_admin_view && !incentive_portal_manager_view)
    let sorterData = {
      ...sorters,
      sort_val: sorters?.sort_val ? sorters?.sort_val : "asc",
    };
    dispatch(
      fetchTicketsList({
        ...pagination,
        offset: offset,
        status_id: selectedStatus,
        ...filter,
        ...sorterData,
      })
    );

    dispatch(fetchTicketsListCount(filter)).then((val: any) => {
      if (val?.payload?.data?.data) {
        setCountsData({
          open: val?.payload?.data?.data?.open
            ? val?.payload?.data?.data?.open
            : 0,
          closed: val?.payload?.data?.data?.closed
            ? val?.payload?.data?.data?.closed
            : 0,
        });
      }
    });
  };
  // console.log("tickets", tickets);
  async function filterFormSubmit(changed: any, all: any) {
    if (changed.type == "team") {
      contact_roles?.length == 0 && dispatch(getContactRoles());
    }
    if (changed.type) {
      delete all.role;
      delete all.contact_ids;
      // setFilters(changed);
    }
    if (changed?.role) {
      setEmployeeList([]);
      await dispatch(getContactEmployeesByIds(changed?.role)).then(
        (val: any) => {
          if (val?.payload?.data?.data) {
            setEmployeeList(
              [...val?.payload?.data?.data].map((emp: any) => {
                return {
                  name: emp?.first_name + " " + emp?.last_name,
                  value: emp?.id,
                };
              })
            );
          }
        }
      );
    }
    setFilters(all);
  }

  const formElements = {
    onFinish: () => {},
    onFinishFailed: () => {},
    onValuesChange: filterFormSubmit,
    initialValues: { ...filters },
    filtersApplied: filters
      ? Object.keys(
          Object.fromEntries(
            Object.entries(filters).filter(([_, v]) => v != null)
          )
        ).length
      : 0,
    setValues: {
      ...filters,
    },
    formElements: ( incentive_portal_manager_view || incentive_portal_admin_view )
      ? [
          {
            type: "Select",
            name: "type",
            colSpan: screenType.mobile ? 12 : 3,
            placeholder: "Type",
            options: [
              { value: "self", name: "Self" },
              ...(incentive_portal_manager_view ? [{ value: "team", name: "Team" }]: []),
              ...(incentive_portal_admin_view ? [{value: "*", name: "Admin"}] : [])
            ],
          },
          ...(filters?.type == "team"
            ? [
                {
                  type: "Select",
                  name: "role",
                  colSpan: screenType.mobile ? 12 : 4,
                  placeholder: "Select Role",
                  options: contact_roles?.map((val: any) => {
                    return { name: val.role_name, value: val.id };
                  }),
                },
                {
                  type: "Select",
                  name: "contact_ids",
                  colSpan: screenType.mobile ? 24 : 5,
                  placeholder: "Select Employee",
                  options: employeeList,
                },
              ]
            : []),
        ]
      : [],
  };
  // console.log(formElements);
  // const allStatus = [
  //   { name: "Open", key: "open" },
  //   { name: "Closed", key: "closed" },
  // ];

  var allTabs = statusList.map((val: any) => {
    return {
      title: (
        <span className="capitalize">
          {formatDropDownValue(val.name).toLowerCase()} (
          {countsData[formatDropDownValue(val.name).toLowerCase()] || 0})
        </span>
      ),
      key: val.id,
      component: (
        <>
          <Row className="padding10">
            <Col span={24}>
              <TableLayout
                pageType="withTab"
                defaultCurrentPage={pagination.offset / pagination.limit + 1}
                loading={loading_tickets}
                buttonEvt={() => {}}
                dataSource={tickets}
                filters="multiple"
                columns={columns}
                onChange={(e, ee) => onPageChange(e, ee)}
                type="morefilters"
                total={pagination.total}
                showTotal={true}
                pagination={{
                  position: ["none", "none"],
                  pageSize: pagination.limit,
                }}
                formData={formElements}
                maxWidth={1500}
                defaultPageSize={10}
                showSizeChangerFlag={false}
              />
            </Col>
          </Row>
        </>
      ),
    };
  });

  const onTabChange = (e: any) => {
    setListData([]);
    // setPagination({ limit: 10, page: 1 });
    setSelectedStatus(statusList[e - 1].id);
  };
  const onPageChange = (e: any, pageSize: any) => {
    let offset = (e - 1) * pagination.limit;
    loadList(offset);
  };
  useEffect(() => {
    dispatch(setBlurModal(ticketFormVisible));
  }, [ticketFormVisible]);

  return (
    <Fragment>
      <PageHeader
        ghost={false}
        className={screenType.mobile ? "" : "employee"}
        title={
          <Row
            style={screenType.mobile ? { paddingLeft: "25px" } : {}}
            align="middle"
          >
            <Col flex="auto" className="title-text">
              Tickets
            </Col>
            {/* {screenType.mobile ? <></> :  */}
          </Row>
        }
        extra={
          <Button
            key="1"
            onClick={() => {
              setTicketFormVisible(true);
            }}
          >
            Create Ticket
          </Button>
        }
      ></PageHeader>

      <Row className="content-area">
        <Col span={24} className="crm-tabs">
          <TabsLayout AllTabs={allTabs} onChange={onTabChange}></TabsLayout>
        </Col>
      </Row>
      {ticketFormVisible && (
        <CreateTicket
          formVisible={ticketFormVisible}
          setFormVisible={setTicketFormVisible}
          reloadTickets={()=>loadList(pagination.offset)}
        />
      )}
      {/* <Button onClick={() => openLoadingModal("Creating Ticket")}>
        Open Loading
      </Button>
      <Button
        onClick={() =>
          openSuccessModal(
            "Ticket Reported Successfully",
            "Reference id for Ticket : #ABC16222212"
          )
        }
      >
        Open Success
      </Button>
      <Button
        onClick={() =>
          openWarningModal(
            "Since you were absent in May’23 therefore no incentive has been disbursed",
            "Do you still want to continue?"
          )
        }
      >
        Open Warning
      </Button> */}
    </Fragment>
  );
}

export default TicketsPage;
